import React, { useMemo } from "react";
import { Stack, Typography,Tooltip } from "@mui/material";
import { grey } from "@mui/material/colors";

const GroupedChip = ({mainText="",secondaryText="",size='medium',sx={},tooltipText=""}) => {
    const paddingSize=useMemo(()=>{
        switch (size) {
            case 'small':
                return '1px 4px'
            case 'medium':
                return '4px 8px'
            case 'large':
                return '4px 8px'
                
                break;
        
            default:
                break;
        }
    },[size])
  return  <Stack direction='row' spacing={0.5} alignItems={'center'} sx={{border:'1px solid',borderColor:theme=>grey[400],borderRadius:'6px'}}>
    <Tooltip title={tooltipText} arrow disableInteractive>
  <Typography variant={size==='small'?'caption':''} sx={{p:paddingSize,backgroundColor:'#D9EDFD',color:grey[700],borderRadius:'6px 0px 0px 6px',...sx}} fontWeight={500}>{mainText}:</Typography>
  </Tooltip>
  <Typography variant={size==='small'?'caption':''} sx={{p:paddingSize,...sx}}>{secondaryText}</Typography>
</Stack>
};

export default GroupedChip;
